import { render, staticRenderFns } from "./ModalToneladasAtendidasOntem.vue?vue&type=template&id=89564a90"
import script from "./ModalToneladasAtendidasOntem.vue?vue&type=script&lang=js"
export * from "./ModalToneladasAtendidasOntem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports